module.exports = __webpack_public_path__ + "img/lezhi05.fbcb32ce.png";